import { FieldPath } from 'react-hook-form'
import i18n from 'i18next'
import i18next from 'i18next'
import { RadioOption } from '@microservices/wiskey-react-components/dist/hookFormControllers/RadioGroupController'
import { ColumnDef } from '@tanstack/react-table'

import { GETAction, GETEntityColumn, TimeLineGridConfig } from '@types'

import { BIND_TYPE } from './tables'

export const TIME_LINE_COLUMN_WIDTH = 250

export const TIME_LINE_URL_SIZE = 100

export const TIME_LINE_EXPAND_FILED_PREFIX = 'expands_'

export const BOTTOM_PINNED_TOTAL_ROW_ID = 'bottom_pinned_total_row_id'

export const TIME_LINE_GROUP_PREFIX = 'time_line_group_'

export const TIME_LINE_CREATE_OR_EDIT_STEPS = [
  i18n.t('timeLinesCreateOrEdit.tab.general'),
  i18n.t('timeLinesCreateOrEdit.tab.objectY'),
  i18n.t('timeLinesCreateOrEdit.tab.objectX'),
  i18n.t('timeLinesCreateOrEdit.tab.mainObject'),
]

export const TIME_LINE_OBJECT_X_CELL_BIND_TYPES = [
  { id: BIND_TYPE.JSX, label: BIND_TYPE.JSX },
  { id: BIND_TYPE.JS, label: BIND_TYPE.JS },
]

export const TIME_LINE_MAIN_OBJECT_GROUP_TITLE_TYPES = [
  { id: BIND_TYPE.JSX, label: BIND_TYPE.JSX },
  { id: BIND_TYPE.JS, label: BIND_TYPE.JS },
]

export const TIME_LINE_OBJECT_TOTAL_ROW_BIND_TYPES = [
  { id: BIND_TYPE.JSX, label: BIND_TYPE.JSX },
  { id: BIND_TYPE.JS, label: BIND_TYPE.JS },
]

export const TIMELINE_COLUMNS: ColumnDef<GETEntityColumn>[] = [
  {
    accessorKey: 'code',
    header: i18next.t('viewColumnsTable.id'),
    meta: { flex: 1 },
  },
  {
    accessorKey: 'title',
    header: i18next.t('viewColumnsTable.title'),
    meta: { flex: 1 },
  },
  {
    accessorKey: 'bindType',
    header: i18next.t('viewColumnsTable.bindType'),
    meta: { flex: 1 },
  },
  {
    accessorKey: 'value',
    header: i18next.t('viewColumnsTable.value'),
    meta: { flex: 1 },
  },
]

export const TIMELINE_OBJECT_X_COLUMNS: ColumnDef<GETEntityColumn>[] = [
  {
    accessorKey: 'code',
    header: i18next.t('viewColumnsTable.id'),
    meta: { flex: 1 },
  },
  {
    accessorKey: 'title',
    header: i18next.t('viewColumnsTable.title'),
    meta: { flex: 1 },
  },
  {
    accessorKey: 'bindType',
    header: i18next.t('viewColumnsTable.bindType'),
    meta: { flex: 1 },
  },
  {
    accessorKey: 'value',
    header: i18next.t('viewColumnsTable.value'),
    meta: { flex: 1 },
  },
  {
    accessorKey: 'pinnedColumn',
    header: i18next.t('viewColumnsTable.pinnedColumn'),
    meta: { flex: 1 },
  },
]

export const TIMELINE_ACTION_COLUMNS: ColumnDef<GETAction>[] = [
  {
    accessorKey: 'code',
    header: i18next.t('viewActionsTable.id'),
    meta: { flex: 1 },
  },
  {
    accessorKey: 'title',
    header: i18next.t('viewActionsTable.title'),
    meta: { flex: 1 },
  },
  {
    accessorKey: 'eventCode',
    header: i18next.t('viewActionsTable.eventCode'),
    meta: { flex: 1 },
  },
  {
    accessorKey: 'actionCode',
    header: i18next.t('viewActionsTable.actionCode'),
    meta: { flex: 1 },
  },
]

export enum TIMELINE_CONFIG_STEPS {
  GENERAL = 'General',
  OBJECT_Y = 'Object Y',
  OBJECT_X = 'Object X',
}

export const TIMELINE_GENERAL_FORM_FIELD_KEYS: Array<FieldPath<TimeLineGridConfig>> = [
  'code',
  'title',
]
export const TIMELINE_OBJECT_Y_FORM_FIELD_KEYS: Array<FieldPath<TimeLineGridConfig>> = ['objectY']
export const TIMELINE_OBJECT_X_FORM_FIELD_KEYS: Array<FieldPath<TimeLineGridConfig>> = ['objectX']

export const TIMELINE_FORM_STEP_FIELDS: Record<number, Array<FieldPath<TimeLineGridConfig>>> = {
  0: TIMELINE_GENERAL_FORM_FIELD_KEYS,
  1: TIMELINE_OBJECT_Y_FORM_FIELD_KEYS,
  2: TIMELINE_OBJECT_X_FORM_FIELD_KEYS,
}

export const MAIN_OBJECT_TYPE_X = 'X'
export const MAIN_OBJECT_TYPE_Y = 'Y'

export const MAIN_OBJECT_RADIO_OPTIONS: RadioOption[] = [
  {
    value: MAIN_OBJECT_TYPE_Y,
    label: 'Y',
  },
  {
    value: MAIN_OBJECT_TYPE_X,
    label: 'X',
  },
]

export const TIME_LINE_INFINITE_SCROLL_Y_PAGINATION_SIZE = '40'
export const TIME_LINE_PAGINATION_SIZE = '1000'

export const TIME_LINE_WEEKEND_HEADER_CLASS_NAME = 'time_line_weekend_header'
export const TIME_LINE_DATE_INTERVAL_CELL_CLASS_NAME = 'time_line_date_interval_cell_style'
export const TIME_LINE_DATE_INTERVAL_CELL_JSX_PARSER_CLASS_NAME =
  'time_line_date_interval_cell_jsx_parser_style'

export const TIME_LINE_CELL_MAX_ITEMS_COUNT = 4
